import ChatLayout from '../components/layouts/ChatLayout.vue'
import ChatAdminAuthorizationPage from '../pages/ChatAdminAuthorizationPage.vue'
import ChatAdminConversationsPage from '../pages/ChatAdminConversationsPage.vue'
import ChatAdminPage from '../pages/ChatAdminPage.vue'
import ChatAdminUserAccessPage from '../pages/ChatAdminUserAccessPage.vue'
import ChatIndexPage from '../pages/ChatIndexPage.vue'
import ChatShowPage from '../pages/ChatShowPage.vue'

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
  {
    // This is the parent route for your package.
    // It uses the layout component.
    path: '/chat',
    name: 'chat.root',
    component: ChatLayout,
    meta: {
      requiresAuth: true,
      permission: 'chat access',
      title: 'chat.nav.title',
      layout: 'Authenticated',
    },
    // All other package routes are children of this layout
    children: [
      {
        // Child path is empty, so it renders at /chat
        path: '',
        name: 'ChatIndexPage',
        component: ChatIndexPage,
      },
      {
        path: 'admin',
        name: 'ChatAdminPage',
        component: ChatAdminPage,
        meta: {
          permission: 'chat administer',
          title: 'chat.admin.title',
        },
        children: [
          {
            path: '',
            name: 'ChatAdminAuthorizationPage',
            component: ChatAdminAuthorizationPage,
          },
          {
            path: 'conversations',
            name: 'ChatAdminConversationsPage',
            component: ChatAdminConversationsPage,
          },
          {
            path: 'users',
            name: 'ChatAdminUserAccessPage',
            component: ChatAdminUserAccessPage,
          },
        ],
      },
      {
        path: ':conversation',
        name: 'ChatShowPage',
        component: ChatShowPage,
      },
      // --- Example of other child routes ---
      // {
      //   path: 'create', // Renders at /chat/create
      //   name: 'chat.create',
      //   component: () => import('../components/Create.vue'),
      // },
    ],
  },
]
